import { defineComponent as a, createBlock as o, openBlock as n, mergeProps as r, resolveDynamicComponent as s, unref as i } from "vue";
import { useBindCx as l } from "@scalar/use-hooks/useBindCx";
import p from "./ScalarIcon.vue.js";
import { variants as c } from "./variants.js";
const m = {}, y = /* @__PURE__ */ a({
  ...m,
  inheritAttrs: !1,
  __name: "ScalarIconLegacyAdapter",
  props: {
    icon: {},
    label: {},
    weight: {},
    logo: {},
    size: {},
    thickness: {}
  },
  setup(f) {
    const { cx: t } = l();
    return (e, u) => typeof e.icon == "string" ? (n(), o(p, r({ key: 0 }, { ...e.$props, ...e.$attrs }, { icon: e.icon }), null, 16, ["icon"])) : (n(), o(s(e.icon), r({
      key: 1,
      label: e.label,
      weight: e.weight
    }, i(t)(i(c)({ size: e.size }))), null, 16, ["label", "weight"]));
  }
});
export {
  y as default
};
